import type { InputHTMLAttributes, Ref } from "react";

import { control } from "./styles";

/**
 * A text input that looks like the rest of the platform.
 *
 * Deliberately thin. It is still a real `<input>` - every native behaviour a
 * browser gives a text field is worth more than anything that could replace it,
 * and the only thing wrong with the native one was that it looked like 2009.
 * So this is styling plus one prop.
 */
export function TextInput({
  invalid = false,
  className = "",
  ref,
  ...rest
}: InputHTMLAttributes<HTMLInputElement> & {
  /** Draws the error border. The message belongs to `Field`. */
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}) {
  return <input ref={ref} className={control(invalid, className)} {...rest} />;
}
